module.exports = __webpack_public_path__ + "static/media/product-compare.cd2672bb.png";